module.exports = __webpack_public_path__ + "img/album15_20.9d885719.jpg";